export const headerLinks = [
  {
    text: 'Ресурсни центар',
    href: '/resursi',
  },
  {
    text: 'Вести',
    href: '/vesti',
  },

  {
    text: 'Контакт',
    href: '/kontakt',
  },
];

export const headerLinksEn = [
  {
    text: 'News',
    href: '/en/news',
  },

  {
    text: 'Contact',
    href: '/en/contact',
  },
];

export const footerLinks = [
  {
    text: "О Светионику",
    href: "/o-nama"
  },
  {
    text: 'Ресурсни центар',
    href: '/resursi',
  },
  { 
    text: "Генерације светионика",
    href: '/generacije-svetionika'
  },
  {
    text: 'Вести',
    href: '/vesti',
  },
  {
    text: 'Контакт',
    href: '/kontakt',
  },
];

export const footerLinksEN = [
  {
    text: "About",
    href: "/en/about"
  },
  { 
    text: "Lighthouse Generations",
    href: '/en/lighthouse-generations'
  },
  {
    text: 'News',
    href: '/en/news',
  },
  {
    text: 'Contact',
    href: '/en/contact',
  },
];
